var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLillogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000066484931048187423220000015313614743088446633_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.7 41.7",
    style: {
      enableBackground: "new 0 0 39.7 41.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n\t.st1{fill:#FFBD2B;}\r\n\t.st2{fill:#3F523A;}\r\n\t.st3{fill:#E6E6E6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 31.5,
    className: "st0",
    width: 39.3,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.1,
    className: "st1",
    width: 39.3,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 15.6,
    className: "st2",
    width: 26.4,
    height: 10.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3,
    y: 15.6,
    className: "st3",
    width: 10.3,
    height: 10.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLillogo);
export default __webpack_public_path__ + "static/media/lillogo.4ffc7a094f5ddbee91c3e6e61dc54ca2.svg";
export { ForwardRef as ReactComponent };